let CURRENT_PROJECT_ID = '';

export const setCurrentProjectId = (id) => {
  CURRENT_PROJECT_ID = id;
};

export const buildStorageUrl = (fileName) => {
  const path = encodeURIComponent(`extraction/${CURRENT_PROJECT_ID}/media/${fileName}`);
  return `https://firebasestorage.googleapis.com/v0/b/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/o/${path}?alt=media`;
};

// Resolves the pre-rendered slide webp from Firebase Storage. slideNumber is 1-based.
export const buildSlideImageUrl = (slideNumber) => buildStorageUrl(`sld${slideNumber}.webp`);

// local, module-scoped cache
const imgCache = new Map();

function resolveImageUrl(url) {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return buildStorageUrl(url);
}

function getCachedImage(src) {
  return imgCache.get(src) || null;
}

function loadImageBrowser(src) {
  return new Promise((resolve, reject) => {
    if (!src) return resolve(null);
    if (imgCache.has(src)) return resolve(imgCache.get(src));

    const img = new Image();
    // img.crossOrigin = 'anonymous'; // enable if storage has proper CORS
    img.decoding = 'async';

    img.onload = () => {
      imgCache.set(src, img);
      resolve(img);
    };

    img.onerror = reject;

    img.src = src;
  });
}

export { resolveImageUrl, getCachedImage, loadImageBrowser };
